import {
    DELETE_POINT_OF_INTEREST_IMAGE,
    DELETE_POINT_OF_INTEREST_IMAGE_FAILURE,
    DELETE_POINT_OF_INTEREST_IMAGE_SUCCESS,
} from 'store/actions/types';

export const deletePointOfInterestImage = (payload) => {
    return {
        type: DELETE_POINT_OF_INTEREST_IMAGE,
        payload: payload,
    };
};

export const deletePointOfInterestImageFailure = (error) => {
    return {
        type: DELETE_POINT_OF_INTEREST_IMAGE_FAILURE,
        error: error,
    };
};

export const deletePointOfInterestImageSuccess = (payload) => {
    return {
        type: DELETE_POINT_OF_INTEREST_IMAGE_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/pointsofinterest/images/deletePointsOfInterestImage.js